import Page, { PageRoute } from '../components/Page';
import useEntryTrack from '../hooks/useEntryTrack';
import { orderRouteAccess } from '../Order';
import { ReactComponent as PaySvg } from '../assets/pay.svg';
import Icon from '@ant-design/icons/lib/components/Icon';

import Scenario from '../Scenario/Scenario';

export const route: PageRoute = {
  path: 'pay',
  i18nHelmetTitle: 'marketing.催付款',
  menu: {
    label: '催付款',
    icon: <Icon component={PaySvg} />,
  },
  element: <Pay />,
  access: orderRouteAccess,
};

function Pay() {
  useEntryTrack('aide/pay');

  return (
    <Page
      route={{
        ...route,
        element: <Scenario scenarioType="PAYMENT_REMINDER" />,
      }}
    />
  );
}

export default Pay;
